import { render, staticRenderFns } from "./ContainerPayPal.vue?vue&type=template&id=0689071a&scoped=true"
import script from "./ContainerPayPal.vue?vue&type=script&lang=js"
export * from "./ContainerPayPal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0689071a",
  null
  
)

export default component.exports